import toolResult from './creators/toolResult';

export default function toolError(message: string) {
  const error = `Tool failed with the following error: ${message}`;

  return toolResult(error);
}
